/**
 * Wrapper para evitar incompatibilidade de tipos do terra-draw com TypeScript 3.9.
 */
export interface GeoJSONStoreFeatures {
  id?: string | number;
  geometry: {
    type: string;
    coordinates: number[][] | number[][][];
  };
  properties?: Record<string, unknown>;
}

// eslint-disable-next-line @typescript-eslint/no-var-requires
const terraDraw = require("terra-draw/dist/terra-draw.cjs");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const terraDrawAdapter = require(
  "terra-draw-google-maps-adapter/dist/terra-draw-google-maps-adapter.cjs"
);

export const TerraDraw = terraDraw.TerraDraw;
export const TerraDrawLineStringMode = terraDraw.TerraDrawLineStringMode;
export const TerraDrawPolygonMode = terraDraw.TerraDrawPolygonMode;
export const TerraDrawRectangleMode = terraDraw.TerraDrawRectangleMode;
export const TerraDrawRenderMode = terraDraw.TerraDrawRenderMode;
export const TerraDrawGoogleMapsAdapter =
  terraDrawAdapter.TerraDrawGoogleMapsAdapter;

export type TerraDrawInstance = InstanceType<typeof TerraDraw>;
